import Vue from 'vue'
import SetPaymentPasswordPopupVue from "./beilin/SetPaymentPasswordPopup";

const SetPaymentPasswordPopup = Vue.extend(SetPaymentPasswordPopupVue);
let setPaymentPasswordPopupInstance;

Vue.prototype.$beilinTools = {
    setPaymentPasswordPopup(){
        if(!setPaymentPasswordPopupInstance){
            const elem = document.createElement('div');
            setPaymentPasswordPopupInstance = new SetPaymentPasswordPopup();
            setPaymentPasswordPopupInstance.$mount(elem);
            document.body.appendChild(setPaymentPasswordPopupInstance.$el);
        }
        // setPaymentPasswordPopupInstance.open();
        // loadingInstance.$on('close', function () {
        //     document.body.removeChild(loadingInstance.$el);
        //     loadingInstance = null;
        // });
        return setPaymentPasswordPopupInstance;
    },
};



// WEBPACK FOOTER //
// ./src/components/index.js